import { render, staticRenderFns } from "./payoutBatchNotify.vue?vue&type=template&id=3455b99c&scoped=true"
import script from "./payoutBatchNotify.vue?vue&type=script&lang=ts"
export * from "./payoutBatchNotify.vue?vue&type=script&lang=ts"
import style0 from "./payoutBatchNotify.vue?vue&type=style&index=0&id=3455b99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455b99c",
  null
  
)

export default component.exports